// extracted by mini-css-extract-plugin
module.exports = {"emptyImage":"ThumbnailImage_emptyImage__3G9vo"};